import React, { useEffect, useState } from 'react'
import Editor from './Editor'
import LoginModal from './LoginModal'
import { useAppStore } from '../store/useAppStore'


const Esper = () => {
  const {
    isAuthenticated,
    checkAuthStatus
  } = useAppStore()
  
  const [showLoginModal, setShowLoginModal] = useState(true)

  // Check authentication status on mount
  useEffect(() => {
    console.log('Checking auth status on mount')
    checkAuthStatus()
  }, [checkAuthStatus])

  // Show login modal immediately if not authenticated
  useEffect(() => {
    console.log('Auth effect triggered:', { isAuthenticated, showLoginModal })
    setShowLoginModal(!isAuthenticated)
  }, [isAuthenticated])

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 dark:from-gray-900 dark:via-blue-900/20 dark:to-purple-900/20">
        <LoginModal
          isOpen={showLoginModal}
        />
      </div>
    )
  }

  return (
    <div className="editor-container">
      <Editor />
    </div>
  )
}

export default Esper 